/**
 * The files an answer names (docs/refactor/51, N6): what the AI made — "C:\…\videos\promo.mp4",
 * `relatorio/vendas.xlsx` — so the answer can offer "Abrir" and "Mostrar na pasta" instead of a path the
 * person has to find. Relative paths are read against the folder the agent worked in. Only names with an
 * extension count: a folder or a word with a slash is not a file to open.
 */

const WINDOWS = /[A-Za-z]:[\\/](?:[^\s"'`<>|*?\r\n()[\]]+[\\/])*[^\s"'`<>|*?\r\n()[\]\\/]+\.[A-Za-z0-9]{1,6}\b/g
const UNIX = /(?<![\w.:])\/(?:[^\s"'`<>|*?\r\n()[\]]+\/)+[^\s"'`<>|*?\r\n()[\]/]+\.[A-Za-z0-9]{1,6}\b/g
const ADDRESS = /\b[a-z][a-z0-9+.-]*:\/\/[^\s"'`<>)]+/gi
const RELATIVE =/(?<![\w:\\/.])(?:\.{1,2}[\\/])?(?:[\w.-]+[\\/])+[\w.-]+\.[A-Za-z0-9]{1,6}\b/g

/** Joins a relative path to the folder, with the folder's own separator; `..` is left out on purpose. */
function under(folder: string, relative: string): string | null {
  const parts = relative.replace(/\\/g, '/').split('/').filter((p) => p && p !== '.')
  if (parts.includes('..')) return null
  const separator = folder.includes('\\') ? '\\' : '/'
  return folder.replace(/[\\/]+$/, '') + separator + parts.join(separator)
}

/** The files named in `text`, absolute, once each, in the order they appear; at most `max`. */
export function filesMentioned(source: string, folder: string | null, max = 8): string[] {
  // A web address is not a file here, whatever its path looks like.
  const text = source.replace(ADDRESS, ' ')
  const found: string[] = []
  const add = (path: string | null) => {
    if (!path) return
    const clean = path.replace(/[.,;:]+$/, '')
    if (!found.some((p) => p.toLowerCase() === clean.toLowerCase())) found.push(clean)
  }
  for (const match of text.matchAll(WINDOWS)) add(match[0])
  for (const match of text.matchAll(UNIX)) add(match[0])
  if (folder) {
    // Taken out first: the absolute paths, so their tails are not read again as relative ones.
    const rest = text.replace(WINDOWS, ' ').replace(UNIX, ' ')
    for (const match of rest.matchAll(RELATIVE)) {
      // A web address is not a file here.
      if (/^(?:www\.|[\w-]+\.(?:com|ai|io|org|net|dev|app)[\\/])/i.test(match[0])) continue
      add(under(folder, match[0]))
    }
  }
  return found.slice(0, max)
}

/** The file's own name, for the button's label. */
export function fileName(path: string): string {
  return path.split(/[\\/]/).pop() ?? path
}
